import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AppInput from "../../../components/AppInput";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import SelectInput from "../../../components/SelectInput";
import { Button, Input, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import useDocumentUpload from "../../../hooks/useDocumentUpload";
import { ErrorToast } from "../../../widgets/AppToast";
import TextArea from "antd/es/input/TextArea";

function ViewCargoRecordBook() {
  const { cargo_id } = useParams();
  const [errors, set_errors] = useState({});
  const [code, set_code] = useState("");
  const [date, set_date] = useState("");
  const [signature, set_signature] = useState("");
  const [codeList, setCodeList] = useState([]);
  const [codeItemList, setCodeItemList] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [initialDocument, setInitialDocument] = useState([]);
  const { documentList, handleDocumentChange } =
    useDocumentUpload(initialDocument);

  const LIST_CARGO_RECORD_CODE_API = () => {
    try {
      const FORM_DATA = new FormData();
      post(ApiURL.list_cargo_codes_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          const newRespones = res?.cargo_codes?.map((item) => {
            return {
              value: item?.value,
              label: item?.label,
            };
          });
          LIST_CARGO_RECORD_ITEM_API(newRespones?.[0]?.value);
          setCodeList(res?.cargo_codes);
        }
      });
    } catch (error) {
      console.error("Error fetching Code list:", error);
    }
  };

  const LIST_CARGO_RECORD_ITEM_API = (code_id) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("code", code_id);
      post(ApiURL.get_cargo_item_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          const newRes = res?.items?.map((item) => {
            return {
              value: item?.id,
              label: item?.description,
              sub_code_name: item?.subdetails_child,
            };
          });
          setCodeItemList(newRes);
        }
      });
    } catch (error) {
      console.error("Error fetching Code Item list:", error);
    }
  };

  const VIEW_CARGO_RECORD_BOOK_APIS = () => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("record_id", atob(cargo_id));
    post(ApiURL.single_cargo_record_com, FORM_DATA).then((res) => {
      if (res?.status == true) {
        const oilRecordData = res?.record;
        set_code(oilRecordData?.operationCode);
        const subDetailValues = oilRecordData?.sub_detail_values || [];
        setSelectedItems(
          Array.isArray(subDetailValues)
            ? subDetailValues
            : typeof subDetailValues === "string" &&
              subDetailValues.trim() !== ""
            ? JSON.parse(subDetailValues)
            : []
        );
        set_date(oilRecordData?.date);
        set_signature(oilRecordData?.cargo_sign);
        setInitialDocument(oilRecordData?.files);
      } else {
        const errors = res?.errors || {};
        set_errors(errors);
      }
    });
  };

  useEffect(() => {
    if (code) LIST_CARGO_RECORD_ITEM_API(code);
  }, [code]);

  useEffect(() => {
    LIST_CARGO_RECORD_CODE_API();
    VIEW_CARGO_RECORD_BOOK_APIS();
  }, []);

  const getDocUrl = (file) => {
    if (file.url) return file.url;
    if (file.originFileObj) return URL.createObjectURL(file.originFileObj);
    return null;
  };

  const handlePreviews = async (file) => {
    const url = getDocUrl(file);
    if (!url) {
      ErrorToast("Error mesaage", "No preview available for this file");
      return;
    }
    window.open(url, "_blank");
  };

  const groupedOptions = codeItemList.flatMap((item) => {
    const subCodes = Array.isArray(item.sub_code_name)
      ? item.sub_code_name
      : [];

    if (subCodes.length > 0) {
      return {
        label: <p style={{ fontSize: "15px" }}>{item.label}</p>,
        options: subCodes.map((sub, index) => ({
          value: `${item.value}-${index}`,
          label: sub?.subdetails_child || "", // fallback if undefined
        })),
      };
    } else {
      return {
        value: item.value,
        label: item.label || "", // fallback if undefined
      };
    }
  });

  return (
    <>
      <div className="white-container">
        <br />
        <h3>Cargo Record book Information </h3>
        <br />
        <div className="row">
          <div className="col-6">
            <SelectInput
              disabled={true}
              label="Code"
              value={code}
              placeholder=" -- Selecte Code  -- "
              style={{ width: "100%" }}
              onChange={(value) => {
                set_code(value);
                setSelectedItems([]);
              }}
              options={codeList}
              errors={errors?.code}
            />
          </div>
          <div className="col-6">
            <AppInput
              disabled={true}
              type="date"
              label="Date"
              placeholder="Date"
              value={date}
              onChange={(e) => set_date(e.target.value)}
              errors={errors.date}
            />
          </div>
        </div>
        {code && (
          <div
            className="col-12"
            style={{
              lineHeight: "2",
              border: "1px solid #d9d9d9",
              borderRadius: "10px",
            }}
          >
            <strong className="form-label">Select Items:</strong>
            {groupedOptions.map((optionGroup, index) => (
              <div key={index} className="mb-3">
                {/* Main Label as Checkbox */}
                <div className="row align-items-center mb-2">
                  <div className="col-6">
                    <div className="form-check">
                      {optionGroup?.options?.length > 1 ? (
                        ""
                      ) : (
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value={optionGroup.label}
                          checked={selectedItems.some(
                            (item) => item.id === optionGroup.value
                          )}
                          // onChange={() =>
                          //   handleCheckboxChange(optionGroup.value)
                          // }
                          id={`group-checkbox-${index}`}
                        />
                      )}
                      <label
                        className="form-check-label"
                        htmlFor={`group-checkbox-${index}`}
                        style={{ textTransform: "none" }}
                      >
                        {typeof optionGroup.label === "string" ? (
                          <strong>{optionGroup.label}</strong>
                        ) : (
                          <strong>{optionGroup.label.props.children}</strong>
                        )}
                      </label>
                    </div>
                  </div>

                  {/* Input Field for Main Label */}
                  <div className="col-6" style={{ marginLeft: "22px" }}>
                    {selectedItems.some(
                      (item) => item.id === optionGroup.value
                    ) && (
                      <TextArea
                        required
                        maxLength={1000}
                        className="form-control"
                        autoSize={{ minRows: 1 }}
                        placeholder={
                          typeof optionGroup.label === "string"
                            ? optionGroup.label
                            : optionGroup.label.props.children
                        }
                        value={
                          selectedItems.find(
                            (item) => item.id === optionGroup.value
                          )?.value || ""
                        }
                        // onChange={(e) =>
                        //   handleInputChange(optionGroup.value, e.target.value)
                        // }
                      />
                    )}
                  </div>
                </div>

                {/* Sub-options */}
                {optionGroup.options && (
                  <div
                    className="ms-3"
                    style={{ marginLeft: "30px", padding: "10px" }}
                  >
                    {optionGroup.options.map((option) => (
                      <div
                        key={option.value}
                        className="row align-items-center mb-2"
                      >
                        {/* Left Side - Checkbox */}
                        <div className="col-6">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              value={option.value}
                              checked={selectedItems.some(
                                (item) => item.id === option.value
                              )}
                              // onChange={() =>
                              //   handleCheckboxChange(option.value)
                              // }
                              id={`checkbox-${option.value}`}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`checkbox-${option.value}`}
                            >
                              {option.label}
                            </label>
                          </div>
                        </div>

                        {/* Right Side - Input Field */}
                        <div className="col-6" style={{ padding: "5px" }}>
                          {selectedItems.some(
                            (item) => item.id === option.value
                          ) && (
                            <TextArea
                              required
                              maxLength={1000}
                              className="form-control"
                              autoSize={{ minRows: 1 }}
                              placeholder={option.label}
                              value={
                                selectedItems.find(
                                  (item) => item.id === option.value
                                )?.value || ""
                              }
                              // onChange={(e) =>
                              //   handleInputChange(option.value, e.target.value)
                              // }
                            />
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}

        <div className="row" style={{ paddingTop: "10px" }}>
          <div className="col-6">
            <AppInput
              disabled={true}
              label="Sign/ Name of officer incharge / Rank/ Date of entry dd-mmm-yyyy"
              placeholder="Sign/ Name of officer incharge / Rank/ Date of entry dd-mmm-yyyy"
              value={signature}
              onChange={(e) => set_signature(e.target.value)}
              errors={errors.signature}
            />
          </div>
          <div className="col-6">
            <div
              className="input-box"
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                alignItems: "flex-start",
              }}
            >
              <label>Select File</label>
              <Upload
                accept=".pdf,.doc,.docx,.xls,.xlsx"
                multiple
                fileList={documentList}
                onChange={handleDocumentChange}
                onPreview={handlePreviews}
                beforeUpload={() => false}
                listType="picture"
                disabled
              >
                <Button
                  disabled
                  icon={<UploadOutlined />}
                  type="primary"
                  style={{
                    borderRadius: "50%",
                    padding: "10px",
                    width: "40px",
                    height: "40px",
                    marginLeft: "10px",
                  }}
                ></Button>
              </Upload>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ViewCargoRecordBook;
